<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto" />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Reset Your Password</h4>
                  <p>Enter Your New Password</p>
                </div>

                <div>
                  <vs-input
                    ref="password"
                    type="password"
                    data-vv-validate-on="blur"
                    v-validate="'required|min:6'"
                    name="password"
                    label-placeholder="Password"
                    placeholder="Password"
                    v-model="password"
                    class="w-full mt-6"
                  />
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                  <vs-input
                    type="password"
                    v-validate="'min:6|confirmed:password'"
                    data-vv-validate-on="blur"
                    data-vv-as="password"
                    name="confirm_password"
                    label-placeholder="Confirm Password"
                    placeholder="Confirm Password"
                    v-model="confirm_password"
                    class="w-full mt-6"
                  />
                  <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-button
                      class="float-right"
                      @click="resetPassword"
                      :disabled="!validateForm"
                    >Reset Password</vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
 

  </div>
</template>

<script>
import axios from "@/axios.js";
import { alertMixin } from "../../mixin/alertMixin";
import { helperMixin } from "../../mixin/helperMixin";
import { axiosMixin } from "../../mixin/axiosMixin";
export default {
  mixins: [alertMixin, helperMixin, axiosMixin],
  data() {
    return {
      email: "",
      password: "",
      confirm_password: "",
      payLoad: "", 
      endPoint: "checkPasswordRecoveryToken",
      submitEndPoint: "updatePassword",
      settings: {}
    };
  },
  computed: { 
    validateForm() {
      return (
        !this.errors.any() && 
        this.password != "" &&
        this.confirm_password != ""
      );
    },
  },
  methods: {
    rejectApplication() {
      this.showRejectReason = true;
    },
    validateReason() {
      if (this.reasonModel == "") {
        this.errorAlert("Required", "The Reason field is required");
        this.showRejectReason = true;
      } else {
        this.payLoad = Object.assign(this.payLoad, {
          rejectReason: this.reasonModel,
          decision: "reject"
        });
        console.log("reason:", this.reasonModel);
        this.submitNow();
      }
    },
    resetPassword() {
      //add the username and password to the payload
      Object.assign(this.payLoad, { 
        password: this.password,
        token: this.token
      });
      console.log("payload:", this.payLoad);

      this.aronPost(this.submitEndPoint, this.payLoad, "", "")
        .then(response => {
          if (response.data.status == "success") {
            this.settings.title = "Success";
            this.settings.message = response.data.msg;
            this.$router.push({
              name:  'record-approved',
              query: this.settings
            });
          } else {
            this.settings.title = "Failed";
            this.settings.message = response.data.msg;
             this.$router.push({
              name:  'record-rejected',
              query: this.settings
            });
          }

          //go back
        })
        .catch((error, response) => {
          console.log("error ActionContainer reason:", error);
          console.log("error ActionContainer response:", response);
          this.errorAlert("error", error.error);
        });
    },
   
    verifyToken() {
      this.payLoad = { token: this.token };

      this.aronPost(this.endPoint, this.payLoad, "", "")
        .then(response => {
          if (response.data.status == "failed") {
            this.$router.push("/notFound").catch(() => {});
          }
        })
        .catch(error => {
          console.log("error ActionContainer reason:", error);
        });
    }
  },
  created() {
    this.token = this.$route.params.token;
    console.log("this.token:", this.token);
    this.verifyToken();
  }
};
</script>
 